var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.76,
    height: 41.747,
    viewBox: "0 0 79.76 41.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(-21 -133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    d: "M202.272,191.291a10.981,10.981,0,1,0,10.981,10.981A10.981,10.981,0,0,0,202.272,191.291Zm0,10.013a3.863,3.863,0,0,1,.849,7.632v1.3a.849.849,0,0,1-1.7,0v-1.3a3.869,3.869,0,0,1-3.015-3.768.849.849,0,0,1,1.7,0A2.166,2.166,0,1,0,202.272,203a3.863,3.863,0,0,1-.848-7.632v-1.061a.849.849,0,0,1,1.7,0v1.061a3.869,3.869,0,0,1,3.015,3.768.849.849,0,1,1-1.7,0,2.166,2.166,0,1,0-2.166,2.166Z",
    transform: "translate(-141.392 -48.399)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M68.653,179.613A17.16,17.16,0,0,1,78.728,164H56.254A6.252,6.252,0,0,1,51,169.334V189.9a6.449,6.449,0,0,1,5.254,5.5h22.86A17.162,17.162,0,0,1,68.653,179.613Zm-9.507,4.313a4.313,4.313,0,1,1,4.314-4.313A4.313,4.313,0,0,1,59.146,183.926Z",
    transform: "translate(-24.909 -25.739)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    d: "M100.76,133H21v41.747h79.76Zm-3.733,31.924a.849.849,0,0,1-.823.849,4.581,4.581,0,0,0-4.318,4.732.849.849,0,0,1-.849.849H30.553a.849.849,0,0,1-.849-.849,4.717,4.717,0,0,0-4.487-4.732.849.849,0,0,1-.823-.849v-22.1a.849.849,0,0,1,.823-.849,4.572,4.572,0,0,0,4.487-4.562.848.848,0,0,1,.849-.848H91.037a.849.849,0,0,1,.849.848,4.436,4.436,0,0,0,4.318,4.562.849.849,0,0,1,.823.849Z",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M195.9,180.463A15.439,15.439,0,1,0,180.463,195.9,15.439,15.439,0,0,0,195.9,180.463Zm-15.439,12.678a12.678,12.678,0,1,1,12.678-12.678A12.678,12.678,0,0,1,180.463,193.141Z",
    transform: "translate(-119.583 -26.589)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M86.2,240.583a2.616,2.616,0,1,0,2.617,2.616,2.616,2.616,0,0,0-2.617-2.616Z",
    transform: "translate(-51.965 -89.326)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M400.2,240.583a2.616,2.616,0,1,0,2.616,2.616,2.616,2.616,0,0,0-2.616-2.616Z",
    transform: "translate(-312.675 -89.326)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    d: "M318.018,164h-22.3a17.135,17.135,0,0,1-.386,31.395h22.686a6.259,6.259,0,0,1,5.089-5.5V169.333A6.064,6.064,0,0,1,318.018,164ZM315.3,183.926a4.313,4.313,0,1,1,4.313-4.313,4.313,4.313,0,0,1-4.313,4.313Z",
    transform: "translate(-227.777 -25.739)",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.e7c6d4f148108a38d07be76821535fb1.svg";
export { ForwardRef as ReactComponent };